<script>
import CTA from '@phoenix/mixins/components/common/CTA';
import { PhxIcon } from '@phx-styleguides/iwc';

export default {
  components: { PhxIcon },

  mixins: [CTA],

  computed: {
    baseClasses() {
      return ['btn'];
    },
  },
};
</script>

<template>
  <a :href="link" v-bind="attributes" :class="getClasses">
    <span class="btn__text" v-html="getText" />
    <span v-if="icon" class="btn__icon btn__icon--start">
      <phx-icon :icon="icon" :bidirectional="iconBidirectional" />
    </span>
  </a>
</template>
